import { memo } from 'react';
import { Box, Checkbox, FormControlLabel, Stack } from '@mui/material';
import { IClassificationProps, IFormProps } from 'interface/inspection/InspectionInfo';

interface ICheckGroupProps {
  list: IClassificationProps[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  form: IFormProps[];
}
function CheckGroup({ list, onChange, form }: ICheckGroupProps): JSX.Element {
  const chunkSize = 15;
  const column1: IClassificationProps[] = [];
  const column2: IClassificationProps[] = [];

  list.forEach((obj, index) => {
    if (index % (chunkSize * 2) < chunkSize) {
      column1.push(obj);
    } else {
      column2.push(obj);
    }
  });

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        border: '1px solid #ccc',
        padding: 2,
      }}
    >
      <Stack direction="row" spacing={2} justifyContent="stretch">
        {/* 첫 번째 열 */}
        <Stack direction="column" spacing={1}>
          {column1.map(obj => (
            <FormControlLabel
              key={obj.id}
              control={<Checkbox onChange={onChange} name={obj.id} sx={{ p: '7px' }} />}
              label={obj.content}
              checked={form.filter((_form: IFormProps) => _form.id === obj.id)[0]?.value ?? false}
              disabled={obj?.essential}
              sx={obj?.essential ? { display: 'none' } : {}}
            />
          ))}
        </Stack>

        {/* 두 번째 열 */}
        <Stack direction="column" spacing={1}>
          {column2.map(obj => (
            <FormControlLabel
              key={obj.id}
              control={<Checkbox onChange={onChange} name={obj.id} sx={{ p: '7px' }} />}
              label={obj.content}
              checked={form.filter((_form: IFormProps) => _form.id === obj.id)[0]?.value ?? false}
              disabled={obj?.essential}
              sx={obj?.essential ? { display: 'none' } : {}}
            />
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}

export default memo(CheckGroup);
